import { restClient } from '@/Core'

import { DISK_ADMIN_API } from './diskAdminApi'

import type { DiskAdminAuditFilter, DiskAdminAuditPage } from '../Contracts/DiskAdmin'

/**
 * Журнал адміністратора, новіші вперед: `GET /services/disk/admin/audit` з
 * фільтрами періоду (`from`/`to`, дати), автора, події й простору. Лише
 * читання — змінювати чи видаляти записи API не дає.
 */
export const LoadDiskAdminAuditTask = async (
    filter: DiskAdminAuditFilter,
    limit: number,
    offset: number
): Promise<DiskAdminAuditPage> => {
    const searchParams: Record<string, string | number> = { limit, offset }

    for (const [key, value] of Object.entries(filter)) {
        if (typeof value === 'string' && value !== '') searchParams[key] = value
    }

    const response = (await restClient.get(`${DISK_ADMIN_API}/audit`, { searchParams }, { forceRefresh: true })) as unknown as
        | Partial<DiskAdminAuditPage>
        | null

    return { items: response?.items ?? [], total: response?.total ?? 0 }
}
